import { useEffect, useRef } from "react"

/** Notify modal overlay depth only on open/close transitions — avoids double-count on re-renders. */
export function useControlledModalNotify(
  isControlled: boolean,
  open: boolean | undefined,
  notifyModalOpenChange: (open: boolean) => void
) {
  const prevOpenRef = useRef<boolean | undefined>(undefined)

  useEffect(() => {
    if (!isControlled) return

    const wasOpen = prevOpenRef.current === true
    const isOpen = open === true

    if (isOpen && !wasOpen) {
      notifyModalOpenChange(true)
    } else if (!isOpen && wasOpen) {
      notifyModalOpenChange(false)
    }

    prevOpenRef.current = open
  }, [isControlled, open, notifyModalOpenChange])

  useEffect(() => {
    if (!isControlled) return undefined
    return () => {
      if (prevOpenRef.current === true) notifyModalOpenChange(false)
    }
  }, [isControlled, notifyModalOpenChange])
}
